import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenav, MatSidenavContainer } from '@angular/material/sidenav';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule, MatRowDef } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ICreateCompanyContact } from './interfaces/create-company-contact.interface';
import ContactAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/common/embedded/contact/contact.entity';
import { BusinessPartnerContactFunctionService } from 'app/modules/components/business-partners/business-partner/business-partner-contact-function-modal/business-partner-contact-function.service';
import BusinessPartnerContactFunctionAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner-contact-function/business-partner-contact-function.entity';
import { NgSelectComponent } from '@ng-select/ng-select';
import EmailAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/common/embedded/email/email.entity';
import PhoneAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/common/embedded/phone/phone.entity';
import { MatSnackBar } from '@angular/material/snack-bar';

import { PhoneTypeService } from '../../../common/phone-type/phone-type.service.service';
import { PhoneTypeAttributes } from '@albatrosdeveloper/ave-models-package';
import { ICreateCompanyContactEmail } from './interfaces/create-company-contact-email.interface';
import { ICreateCompanyContactPhone } from './interfaces/create-company-contact-phone.interface';
import { CompanyContactEmailService } from './company-contact-phone.service';
import { CompanyContactPhoneService } from './company-contact-email.service';


@Component({
  selector: 'app-add-company-contact-modal',
  styleUrl: './company-contact.component.scss',
  templateUrl: './company-contact.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenav,
    MatSidenavContainer,
    FormsModule,
    MatSelectModule,
    MatTabsModule,
    NgSelectComponent,
  ],
})
export class AddCompanyContactComponent {
  currentCreateCompanyContact: ICreateCompanyContact = this.initializeCreateCompanyContact();
  currentUpdateCompanyContact: ContactAttributes | undefined;
  contactFunctionList: BusinessPartnerContactFunctionAttributes[] = [];


  emailsDataSource: EmailAttributes[] = [];
  phonesDataSource: PhoneAttributes[] = [];
  phoneTypeOptions: PhoneTypeAttributes []= [];
  
  newEmail: ICreateCompanyContactEmail = { email: '', isPrincipal: false };
  newPhone: ICreateCompanyContactPhone = { phone: '', isPrincipal: false, prefix: '',  type: undefined};

  expandedEmailIndex: string | null = null;
  expandedPhoneIndex: string | null = null;

  editedEmailIndex: number | null = null;
  editedEmail: ICreateCompanyContactEmail = { email: '', isPrincipal: false };

  editedPhoneIndex: number | null = null;
  editedPhone: ICreateCompanyContactPhone = { phone: '', isPrincipal: false, prefix: '', type: undefined };

  isEditMode : boolean;
  constructor(
    private readonly phoneTypeService : PhoneTypeService,
    private emailContactService: CompanyContactEmailService,
    private phoneContactService: CompanyContactPhoneService,
    public dialogRef: MatDialogRef<AddCompanyContactComponent>,
    private contactFunctionService: BusinessPartnerContactFunctionService,
    private cdr: ChangeDetectorRef,
    private snackBar: MatSnackBar,
    private changeDetectorRef: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    if (data && Object.keys(data).length > 1) {
      this.isEditMode = true;
    } else {
      this.isEditMode = false;
    }
    if (this.isEditMode) {
      this.currentCreateCompanyContact = { 
        ...data,
        functionId: data.function?._id.toString(),
    };
    if (data && data.emails) {
      this.emailsDataSource = data.emails;
    }else {
      this.emailsDataSource = [];
    }
    if (data && data.phones) {
      this.phonesDataSource = data.phones;
    }else {
      this.phonesDataSource = [];
    }
    }
  }

  ngAfterViewInit(): void {
    this.fetchAllContactFunction();
    this.loadPhoneTypeOptions();
    // this.setupPaginationAndSorting();
    // this.findAllWithCount();
  }

  private initializeCreateCompanyContact(): ICreateCompanyContact {
    return {
      fullName: "",
      firstName: "",
      lastName: "",
      emails: [{ email: "", isPrincipal: false}],
      phones: [{ phone: "", isPrincipal: false, prefix: "", type: undefined }],
      functionId: null,
      isOwnContact: false,
      isPrincipal: false
    }
  }

  createEmail(): void {
    if (!this.newEmail.email) {
      this.snackBar.open("Por favor ingrese un correo válido", "Cerrar", { duration: 3000 });
      return;
    }
    this.emailsDataSource = [...this.emailsDataSource, { ...this.newEmail }];
    // this.emailsDataSource.push({ ...this.newEmail });
    this.newEmail = { email: '', isPrincipal: false };
    this.expandedEmailIndex = 'global';
    this.cdr.detectChanges();
  }

  removeEmail(index: number): void {
    const emailToRemove = this.emailsDataSource[index];

    this.emailsDataSource.splice(index, 1);
    this.emailsDataSource = [...this.emailsDataSource];

    if(this.isEditMode)
    {this.emailContactService
    .deleteEmbedded2d(this.data.companyId,this.data._id,emailToRemove._id.toString(),emailToRemove)
    .subscribe({
      next: () => this.snackBar.open("Correo borrado","Cerrar",{ duration: 5000}),
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al borrar el correo",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });}
  }

  editEmail(index: number, contact: ICreateCompanyContactEmail): void {
    // const emailToEdit = this.emailsDataSource[index];
    this.editedEmailIndex = index;
    this.editedEmail = { ...contact }; 
  }

  saveEditedEmail(index: number): void {
    const emailToEdit = this.emailsDataSource[index];

    if (!this.editedEmail.email.trim()) {
      this.snackBar.open("Por favor ingrese un correo válido", "Cerrar", { duration: 3000 });
      return;
    }

    if(this.isEditMode)
      {this.emailContactService
      .updateEmbedded2d(
        this.data.companyId, this.data._id, emailToEdit._id.toString(), emailToEdit
      )
      .subscribe({
        next: () => this.snackBar.open("Correo actualizado","Cerrar",{ duration: 5000}),
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar el correo",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });}

    // this.emailsDataSource[index] = { ...this.editedEmail };
    this.emailsDataSource = [
      ...this.emailsDataSource.slice(0, index),
      { ...this.editedEmail },
      ...this.emailsDataSource.slice(index + 1),
    ];
    this.changeDetectorRef.detectChanges();

    this.cancelEdit();
  }

  cancelEdit(): void {
    this.editedEmailIndex = null;
    this.editedEmail = { email: '', isPrincipal: false };
  }
  
  toggleEmailRow(): void {
    this.expandedEmailIndex = this.expandedEmailIndex ? null : 'global';
    this.cdr.detectChanges(); 
  }
  
  
  createPhone(): void {
    if (!this.newPhone.phone) {
      this.snackBar.open("Por favor ingrese un telefono válido", "Cerrar", { duration: 3000 });
      return;
    }
    // this.phonesDataSource.push({ ...this.newPhone });
    this.phonesDataSource = [...this.phonesDataSource, { ...this.newPhone }];
    this.newPhone = { prefix: '', phone: '', isPrincipal: false, type: undefined };
    this.expandedEmailIndex = 'global';
    this.cdr.detectChanges();
  }
    
  removePhone(index: number): void {
    const phoneToRemove = this.phonesDataSource[index];

    this.phonesDataSource.splice(index, 1);
    this.phonesDataSource = [...this.phonesDataSource];

    if(this.isEditMode)
      {this.phoneContactService
      .deleteEmbedded2d(this.data.companyId,this.data._id,phoneToRemove._id.toString())
      .subscribe({
        next: () => this.snackBar.open("Teléfono borrado","Cerrar",{ duration: 5000}),
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al borrar el Teléfono",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });}
  }

  editPhone(index: number, contact: ICreateCompanyContactPhone): void {
    const phoneToEdit = this.emailsDataSource[index];

    this.editedPhoneIndex = index;
    this.editedPhone = { ...contact };

    // if(this.isEditMode)
    //   {this.phoneContactService
    //   .updateEmbedded2d(
    //     this.data.companyId, this.data._id, phoneToEdit._id.toString(), phoneToEdit
    //   )
    //   .subscribe({
    //     next: () =>,
    //     error: (err) => {
    //       this.snackBar.open(
    //         err.error.message || "Error al actualizar el correo",
    //         "Cerrar",
    //         { duration: 3000 }
    //       );
    //     },
    //   });}
  }
  
  saveEditedPhone(index: number): void {
    const phoneToEdit = this.emailsDataSource[index];

    if (!this.editedPhone.phone.trim()) {
      this.snackBar.open("Por favor ingrese un teléfono válido", "Cerrar", { duration: 3000 });
      return;
    }
    this.phonesDataSource[index] = { ...this.editedPhone };
    this.phonesDataSource = [
      ...this.phonesDataSource.slice(0, index),
      { ...this.editedPhone },
      ...this.phonesDataSource.slice(index + 1),
    ];
    this.changeDetectorRef.detectChanges();
    this.cancelEditPhone();
  }
  
  cancelEditPhone(): void {
    this.editedPhoneIndex = null;
    this.editedPhone = { phone: '', isPrincipal: false, prefix: '', type: undefined };
  }

  togglePhoneRow(contact: { phone: null } | PhoneAttributes): void {
    this.expandedPhoneIndex = this.expandedPhoneIndex ? null : 'global';
    this.cdr.detectChanges(); 
  }

  private loadPhoneTypeOptions(): void {
    this.phoneTypeService.findToComboBox().subscribe({
      next: (response) => {
        this.phoneTypeOptions = response.data;
      },
      error: (error) => {
        this.snackBar.open(error.error.message || 'Error al cargar las opciones de tipo de teléfono:',"Cerrar",{ duration: 5000});
      }
    });
  }

  getPhoneTypeLabel(typeId: string): string {
    const type = this.phoneTypeOptions.find(option => option._id.toString() === typeId);
    return type ? type.type : 'Desconocido';
  }
  

  private fetchAllContactFunction(): void {
    this.contactFunctionService.findToComboBox().subscribe({
      next: (res) => {
        this.contactFunctionList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener funciones.","Cerrar",{ duration: 5000});
      },
    });
  }

  updateFullName() {
    this.currentCreateCompanyContact.fullName = `${this.currentCreateCompanyContact.firstName} ${this.currentCreateCompanyContact.lastName}`;
  }

  save() {
    this.currentCreateCompanyContact.emails = this.emailsDataSource;
    this.currentCreateCompanyContact.phones = this.phonesDataSource;
    this.dialogRef.close(this.currentCreateCompanyContact);
  }
}
